
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { userStateBaseGuard } from './user-state-base.guard';


export const UserRequiredGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return userStateBaseGuard()?.isActive;
}

